import { cx } from "shared/utils";
import { AssetItem } from "views/applications-id-report/components/SmartRender/AssetItem";
import { parseDocStatus } from "views/applications-id-report/utils/parseDocStatus";
import { Asset } from "views/applications-id-report/slices/IdentityVerificationReportSlice/types";
import { ReasonCode } from "types/landlord/reports";

interface DocumentCardProps {
  score: number;
  asset?: Asset["asset"];
  reason_codes?: ReasonCode[];
  ignorePrint?: boolean;
}

export const DocumentCard = ({
  score,
  asset,
  reason_codes,
  ignorePrint
}: DocumentCardProps) => {
  const status = parseDocStatus(score);

  return (
    <div className="flex gap-4">
      {asset ? (
        <AssetItem
          ignorePrint={ignorePrint}
          url={asset.url || ""}
          content_type={asset.content_type || ""}
          filename={asset.filename || ""}
          assetName={asset.filename || ""}
        />
      ) : null}
      <div
        className={cx(
          "flex flex-col w-full rounded-md p-6 gap-4 border border-alpha-100",
          status === "Accepted" ? "bg-success-50" : "",
          status === "Warning" ? "bg-warning-50" : "",
          status === "Rejected" ? "bg-danger-50" : ""
        )}
      >
        {/* Icon */}
        <div
          className={cx(
            "text-base shrink-0 font-bold h-5 w-5 rounded-full flex items-center justify-center",
            status === "Warning" ? "bg-warning-500 text-warning-50" : "",
            status === "Rejected" ? "bg-danger-500 text-danger-50" : "",
            status === "Accepted" ? "bg-success-500 text-success-50" : ""
          )}
        >
          !
        </div>

        <p className="text-content-400 text-sm font-medium">
          <span className="text-content-1000">
            Authenticity score {score || "-"}
            /100:
          </span>{" "}
          {status === "Accepted"
            ? "We did not find evidence of tampering / fraud this document"
            : ""}
          {status === "Warning"
            ? "We recommend manually reviewing this document as suspicious signals were found"
            : ""}
          {status === "Rejected"
            ? "Based on the below reason codes, we do not believe this document to be authentic"
            : ""}
        </p>

        {reason_codes?.map((item) => {
          return (
            <p
              key={item.code}
              className="font-normal text-content-1000 text-sm first-letter:capitalize border-t border-alpha-40 pt-4"
            >
              {item.description}: {item.confidence || "-"} confidence
            </p>
          );
        })}
      </div>
    </div>
  );
};
